import PropTypes from 'prop-types';

export const DoubleArrow = ({ 
  width = 512, 
  height = 512, 
  color = "#e75d0d",
  arrowColor = "#fff",
  className = "", 
  onClick,
  left = ""
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 512"
      className={className}
      role="img"
      alt="Botão de abrir e fechar"
      aria-label="Botão dupla seta"
      onClick={onClick}
      style={{ 
        alignSelf: "center",
        cursor: onClick ? "pointer" : "default",
        position: "absolute",
        top: "94%",
        left: left
      }}>
      <circle
        cx="256"
        cy="256"
        r="248"
        fill={color}
        stroke="#fff"
        strokeWidth="15"
      />
      <polyline
        points="256 224 352 320 160 320 256 224"
        fill="none"
        stroke={arrowColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        transform="translate(0, -50)"
      />
      <polyline
        points="256 288 352 384 160 384 256 288"
        fill="none"
        stroke={arrowColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        transform="translate(0, -50)"
      />
    </svg>
  );
};

DoubleArrow.propTypes = {
  width: PropTypes.number, 
  height: PropTypes.number, 
  color: PropTypes.string,
  arrowColor: PropTypes.string,
  className: PropTypes.string, 
  onClick: PropTypes.func,
  left: PropTypes.string
};